<template>
  <ad />
</template>

<script>
import Ad from './components/Ad.vue';

export default {
  name: 'App',
  components: {
    Ad,
  },
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

$primary: #1977f2;
$link: #d9f6fa;

// Lists and maps
$custom-colors: null !default;
$custom-shades: null !default;

@import url("https://fonts.googleapis.com/css2?family=Work+Sans&display=swap");
$family-primary: "Work Sans", sans-serif;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: mergeColorMaps(
  (
    "white": (
      $white,
      $black,
    ),
    "black": (
      $black,
      $white,
    ),
    "light": (
      $light,
      $light-invert,
    ),
    "dark": (
      $dark,
      $dark-invert,
    ),
    "primary": (
      $primary,
      $primary-invert,
      $primary-light,
      $primary-dark,
    ),
    "link": (
      $link,
      $link-invert,
      $link-light,
      $link-dark,
    ),
    "info": (
      $info,
      $info-invert,
      $info-light,
      $info-dark,
    ),
    "success": (
      $success,
      $success-invert,
      $success-light,
      $success-dark,
    ),
    "warning": (
      $warning,
      $warning-invert,
      $warning-light,
      $warning-dark,
    ),
    "danger": (
      $danger,
      $danger-invert,
      $danger-light,
      $danger-dark,
    ),
  ),
  $custom-colors
);

$mobile-md: 480px !default;
$mobile-lg: 580px !default;

@mixin mobile-xs {
  @media screen and (max-width: $mobile-md - 1), print {
    @content;
  }
}

@mixin mobile-md {
  @media screen and (min-width: $mobile-md), print {
    @content;
  }
}

@mixin mobile-lg {
  @media screen and (min-width: $mobile-lg), print {
    @content;
  }
}

/**
 * Columns
 */
 .column {
  @include mobile-md {
    &.is-narrow-mobile-md {
      flex: none;
    }

    &.is-full-mobile-md {
      flex: none;
      width: 100%;
    }

    &.is-three-quarters-mobile-md {
      flex: none;
      width: 75%;
    }

    &.is-two-thirds-mobile-md {
      flex: none;
      width: 66.6666%;
    }

    &.is-half-mobile-md {
      flex: none;
      width: 50%;
    }

    &.is-one-third-mobile-md {
      flex: none;
      width: 33.3333%;
    }

    &.is-one-quarter-mobile-md {
      flex: none;
      width: 25%;
    }

    &.is-one-fifth-mobile-md {
      flex: none;
      width: 20%;
    }

    &.is-two-fifths-mobile-md {
      flex: none;
      width: 40%;
    }

    &.is-three-fifths-mobile-md {
      flex: none;
      width: 60%;
    }

    &.is-four-fifths-mobile-md {
      flex: none;
      width: 80%;
    }

    &.is-offset-three-quarters-mobile-md {
      margin-left: 75%;
    }

    &.is-offset-two-thirds-mobile-md {
      margin-left: 66.6666%;
    }

    &.is-offset-half-mobile-md {
      margin-left: 50%;
    }

    &.is-offset-one-third-mobile-md {
      margin-left: 33.3333%;
    }

    &.is-offset-one-quarter-mobile-md {
      margin-left: 25%;
    }

    &.is-offset-one-fifth-mobile-md {
      margin-left: 20%;
    }

    &.is-offset-two-fifths-mobile-md {
      margin-left: 40%;
    }

    &.is-offset-three-fifths-mobile-md {
      margin-left: 60%;
    }

    &.is-offset-four-fifths-mobile-md {
      margin-left: 80%;
    }

    @for $i from 1 through 12 {
      &.is-#{$i}-mobile-md {
        flex: none;
        width: percentage($i / 12);
      }

      &.is-offset-#{$i}-mobile-md {
        margin-left: percentage($i / 12);
      }
    }
  }
  @include mobile-lg {
    &.is-narrow-mobile-lg {
      flex: none;
    }

    &.is-full-mobile-lg {
      flex: none;
      width: 100%;
    }

    &.is-three-quarters-mobile-lg {
      flex: none;
      width: 75%;
    }

    &.is-two-thirds-mobile-lg {
      flex: none;
      width: 66.6666%;
    }

    &.is-half-mobile-lg {
      flex: none;
      width: 50%;
    }

    &.is-one-third-mobile-lg {
      flex: none;
      width: 33.3333%;
    }

    &.is-one-quarter-mobile-lg {
      flex: none;
      width: 25%;
    }

    &.is-one-fifth-mobile-lg {
      flex: none;
      width: 20%;
    }

    &.is-two-fifths-mobile-lg {
      flex: none;
      width: 40%;
    }

    &.is-three-fifths-mobile-lg {
      flex: none;
      width: 60%;
    }

    &.is-four-fifths-mobile-lg {
      flex: none;
      width: 80%;
    }

    &.is-offset-three-quarters-mobile-lg {
      margin-left: 75%;
    }

    &.is-offset-two-thirds-mobile-lg {
      margin-left: 66.6666%;
    }

    &.is-offset-half-mobile-lg {
      margin-left: 50%;
    }

    &.is-offset-one-third-mobile-lg {
      margin-left: 33.3333%;
    }

    &.is-offset-one-quarter-mobile-lg {
      margin-left: 25%;
    }

    &.is-offset-one-fifth-mobile-lg {
      margin-left: 20%;
    }

    &.is-offset-two-fifths-mobile-lg {
      margin-left: 40%;
    }

    &.is-offset-three-fifths-mobile-lg {
      margin-left: 60%;
    }

    &.is-offset-four-fifths-mobile-lg {
      margin-left: 80%;
    }

    @for $i from 1 through 12 {
      &.is-#{$i}-mobile-lg {
        flex: none;
        width: percentage($i / 12);
      }

      &.is-offset-#{$i}-mobile-lg {
        margin-left: percentage($i / 12);
      }
    }
  }
}

/**
 * Visibility
 */
$displays: "block" "flex" "inline" "inline-block" "inline-flex";

@each $display in $displays {
  @include mobile-xs {
    .is-#{$display}-mobile-xs {
      display: #{$display} !important;
    }
  }
  @include mobile-md {
    .is-#{$display}-mobile-md {
      display: #{$display} !important;
    }
  }
  @include mobile-lg {
    .is-#{$display}-mobile-lg {
      display: #{$display} !important;
    }
  }
}

$font-sizes: (
  1: 3rem,   // Very large font size for major headings
  2: 2.5rem, // Large font size for prominent headings
  3: 2rem,   // Medium-large font size, for subheadings
  4: 1.5rem, // Standard font size for titles or important text
  5: 1.25rem,// Slightly larger text, for emphasis or sub-titles
  6: 1rem,   // Default font size for body text
  7: 0.75rem // Small font size for less important or dense text
);

// Define a mixin for generating typography classes
@mixin generate-typography-classes($breakpoint-name) {
  @each $size, $value in $font-sizes {
    .is-size-#{$size}-#{$breakpoint-name} {
      font-size: $value;
    }
  }
}

// Generate classes for each custom breakpoint
@include mobile-xs {
  @include generate-typography-classes("mobile-xs");
}

@include mobile-md {
  @include generate-typography-classes("mobile-md");
}

@include mobile-lg {
  @include generate-typography-classes("mobile-lg");
}

@import "~bulma";

html {
  background-color: transparent;
  overflow: hidden;
}
</style>
